import { ActionTree } from 'vuex'
import axios from 'axios'

import _get from 'lodash/get'

import { BASE_URL } from '@/config'
import { CheckInState } from './types'
import { RootState } from '../types'
import { Seller, Offer, OfferItem } from '@/types'

export const actions: ActionTree<CheckInState, RootState> = {
  getOfferItems({ commit }, payload) {
    const path = `${BASE_URL}/offer-items`
    const params = {
      offerId: payload.offerId,
      limit: payload.limit,
      offset: payload.offset || 0,
      order: payload.order || [],
      filter: payload.filter || {},
    }

    return axios
      .get(path, { params })
      .then(response => {
        const offerItems = _get(response, 'data')
        return offerItems
      })
      .catch(err => {
        throw err
      })
  },
  getOfferItem({ commit }, payload) {
    const path = `${BASE_URL}/offer-item`
    const params = {
      isbn: payload.isbn,
      revisionId: payload.revisionid,
    }
    commit('setRequestGetOfferItem', true)

    return axios
      .get(path, { params })
      .then(response => {
        const data = _get(response, 'data') || null
        commit('setOfferItem', { offerItem: data })
        return data
      })
      .catch(err => {
        commit('setRequestGetOfferItem', false)
        commit('setOfferItem', { offerItem: null })
        throw err
      })
  },
  checkinOfferItem({ commit, getters }, payload: { offerItemId }): any {
    const path = `${BASE_URL}/offer-item/checkin`
    commit('setRequestCheckinOfferItem', true)

    return axios
      .put(path, { id: payload.offerItemId })
      .then(response => {
        const data = _get(response, 'data') || null
        commit('checkedInOfferItem', { offerItem: data })
        return data
      })
      .catch(err => {
        commit('setRequestCheckinOfferItem', false)
        throw err
      })
  },
}
